"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");

















































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      searchData: { userId: '', startTime: '', endTime: '', page: 1, // 当前页码
        rows: 10 // 页码条
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'userId', label: '用户ID', isShow: true }, { prop: 'typeCode', label: '型号', isShow: true }, { prop: 'shoulderInner', label: '肩内', formatter: _formatter.sorenessFormatter, isShow: true }, { prop: 'shoulderOuter', label: '肩外', formatter: _formatter.sorenessFormatter, isShow: true }, { prop: 'scapula', label: '肩胛骨', formatter: _formatter.sorenessFormatter, isShow: true }, { prop: 'neck', label: '颈部', formatter: _formatter.sorenessFormatter, isShow: true }, { prop: 'back', label: '背部', formatter: _formatter.sorenessFormatter, isShow: true }, { prop: 'waist', label: '腰部', formatter: _formatter.sorenessFormatter, isShow: true }, { prop: 'result', label: '酸痛程度', formatter: _formatter.acheDegreeFormatter, isShow: true }, { prop: 'createTime', label: '检测时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: {
    init: function init() {
      var self = this;
      self.getData('/api/painReportDetail', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    checkPermission: _user.checkPermission,
    resetFun: function resetFun() {// 重置
      this.searchData.userId = '';
      this.searchData.startTime = '';
      this.searchData.endTime = '';
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      var start = new Date(this.searchData.startTime);
      var deliverTimeStart = start.getTime();
      var end = new Date(this.searchData.endTime);
      var deliverTimeEnd = end.getTime();
      if (deliverTimeStart > deliverTimeEnd) {
        this.$message({
          message: '请选择结束时间要大于开始时间',
          type: 'error' });

        this.searchData.endTime = '';
        return false;
      }
      if (this.searchData.endTime) {
        var endTime = this.searchData.endTime;
        if (endTime.split(' ').length < 2) {
          endTime = endTime + ' 23:59:59';
          this.searchData.endTime = endTime;
        }
      }
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    excelFun: function excelFun() {
      var self = this;
      var day_30 = 3600 * 30 * 24 * 1000;
      // 校验时间是否填写
      if (self.searchData.startTime === '') {
        self.$message({
          message: '请选择开始时间',
          type: 'error' });

        return false;
      } else if (self.searchData.endTime === '') {
        self.$message({
          message: '请选择结束时间',
          type: 'error' });

        return false;
      } else if (self.searchData.endtime - self.searchData.startTime > day_30) {
        self.$message({
          message: '只能导出小于等于30天的的时间',
          type: 'error' });

        return false;
      }
      if (this.searchData.endTime) {
        var endTime = this.searchData.endTime;
        if (endTime.split(' ').length < 2) {
          endTime = endTime + ' 23:59:59';
          this.searchData.endTime = endTime;
        }
      }
      if (this.searchData.startTime) {
        var startTime = this.searchData.startTime;
        if (startTime.split(' ').length < 2) {
          startTime = startTime + ' 00:00:00';
          this.searchData.startTime = startTime;
        }
      }
      window.location.href = '/api/painReportDetail/export?startTime=' +
      self.searchData.startTime + '&endTime=' + self.searchData.endTime + '&userId=' + self.searchData.userId;
    } } };exports.default = _default;